import Home from "./components/home";
import Offer from "./components/offer";
import Privacy from "./components/privacy-policy";
import Congratulations from "./components/congratulations";
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import ProgrammPage from "./components/programm";
import ScrollToAnchor from "./components/ScrollToAnchor";
import { useEffect, useRef } from 'react';
import { trackEmailClick, trackPageView, trackPhoneClick } from './analytics';

function AnalyticsTracker() {
  const location = useLocation();
  const isFirstPage = useRef(true);

  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest?.('a');
      if (!link) return;

      const href = link.getAttribute('href') || link.href || '';
      if (href.startsWith('tel:')) {
        trackPhoneClick(href.replace('tel:', ''));
        return;
      }
      if (href.startsWith('mailto:')) {
        trackEmailClick(href.replace('mailto:', ''));
      }
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  useEffect(() => {
    if (isFirstPage.current) {
      isFirstPage.current = false;
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <AnalyticsTracker />
            <ScrollToAnchor />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/offer" element={<Offer />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/congratulations" element={<Congratulations />} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
